import './styles.css';

import Image from 'next/image';

import { ChevronRightIcon, StarV2Icon } from '@/shared';

import { Button } from '../../';
import type { IHero } from '../../types';

export const Hero = ({
	pretitle,
	title,
	subtitle,
	image,
	reviews,
	features,
	actionTitle,
	button,
}: IHero) => {
	return (
		<div className="hero">
			{pretitle && <p className="hero-pretitle">{pretitle}</p>}
			<h1 className="hero-title">{title}</h1>
			{subtitle && <p className="hero-subtitle">{subtitle}</p>}

			<Image
				src={image.mobile}
				alt={image.alt}
				width={320}
				height={228}
				className="xl:hidden"
			/>

			<Image
				src={image.desktop}
				alt={image.alt}
				width={580}
				height={415}
				className="absolute bottom-0 right-0 max-xl:hidden"
			/>

			{reviews && (
				<div className="hero-reviews">
					<div className="hero-reviews-item">
						<h3 className="text-sm font-semibold text-[#252F4A] xl:text-2xl/[1.3]">
							{reviews.averageRating.title}
						</h3>
						<div className="flex flex-row text-2xl/[1.3] font-semibold xl:text-5xl/[1.3]">
							<StarV2Icon className="size-6 text-[#6C3EDE] xl:mr-4 xl:size-14" />
							<span>{reviews.averageRating.value}</span>
							<span className="text-[#99A1B7]">/5</span>
						</div>
						<p className="text-xs/[1.2] text-[#4B5675] xl:text-base/[1.2]">
							по отзывам{' '}
							<span className="xl:font-semibold">
								{reviews.averageRating.description}
							</span>{' '}
							студентов
						</p>
					</div>
					<div className="hero-reviews-item">
						<h3 className="text-sm font-semibold text-[#252F4A] xl:text-2xl/[1.3]">
							{reviews.studentsAchievement.title}
						</h3>
						<div className="text-2xl/[1.3] font-semibold xl:text-5xl/[1.3]">
							<span>{reviews.studentsAchievement.value}</span>
						</div>
						<p className="text-xs/[1.2] text-[#4B5675] xl:text-base/[1.3]">
							{reviews.studentsAchievement.description}
						</p>
						{reviews.studentsAchievement.additionalInfo && (
							<p className="text-[10px]/[1.2] text-[#99A1B7] xl:text-xs/[1.2]">
								{reviews.studentsAchievement.additionalInfo}
							</p>
						)}
					</div>
				</div>
			)}

			<div className="max-w-[1400px] items-start max-xl:space-y-2 xl:flex xl:flex-col xl:gap-4 xl:pt-9 2xl:flex-row 2xl:flex-wrap">
				{features.map((feature, index) => (
					<div
						key={index}
						className="rounded-xl bg-white p-4 text-sm/[1.2] font-semibold text-[#4B5675] xl:rounded-[100px] xl:px-6 xl:text-base/[1.2]"
					>
						{feature}
					</div>
				))}
			</div>

			<div className="hero-action-title py-1 xl:pb-3 xl:pt-8 2xl:pt-14">
				{actionTitle}
			</div>

			{button && (
				<Button href={button.href} className="hero-action">
					{button.text}
					<ChevronRightIcon className="size-5" />
				</Button>
			)}
		</div>
	);
};
